export const ARTEFACTS_API = '/plan/artefacts/';

export const ARTEFACT_TYPES_API = '/plan/artefacts/types/';

export const ARTEFACTS_BY_ID_API = (id) => `${ARTEFACTS_API}${id}/`;


// WEBPACK FOOTER //
// ./src/apis/artefacts.js